import { get } from './cookies';

export function hasExt(ext: 'ads' | 'tabs'): boolean {
  return installed().includes(ext);
}

export function installed(): string[] {
  const raw = get('g8-source');

  let orig: any = {};

  try {
    orig = JSON.parse(decodeURIComponent(raw || '{}'));
  } catch (error) {
    orig = {};
  }

  const installed = [];

  if (orig?.adsInstalled) {
    installed.push('ads');
  }

  if (orig?.tabsInstalled) {
    installed.push('tabs');
  }

  return installed;
}
